<template>
    <div id="procurementNotice">
        <div class="notice-title">
            <span class="notice-title-left">采购公告</span>
            <router-link class="notice-title-right" to="/result/public">结果公示</router-link>
        </div>
        <div class="eb-line"></div>
        <div v-for="(notice, index ) in noticeList" :key="index">
            <div class="notice-list-box">
                <div style="width:64px;padding-top:4px;">
                    <div class="noticeList-redline"></div>
                </div>
                <div>
                    <div class="notice-title-box">
                        <div style="position:absolute;font-weight: bold;height:20px;width:838px;overflow:hidden;color:#080808;">....................................................................................................................................................................................................................................................................................................................................................................</div>
                        <div class="notice-list-title ellipsis">{{notice.noticeTitle}}</div>
                        <div class="notice-list-time">{{notice.noticeTime|dateFormatYMD}}</div>

                    </div>
                    <div class="notice-list-content">{{notice.noticeContent}}</div>
                </div>
            </div>
            <div class="eb-line"></div>
        </div>
        <eb-pagination :current-page.sync="pageNumber" v-if="paginationSize" @current-change="paginationData" :total="paginationSize" />
    </div>
</template>
<script>
import { listNotice } from '@/services/notice-service';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
export default {
  name: 'procurementNotice',
  components: {
    ebPagination
  },
  data() {
    return {
      requestData: {
        dateValue: '',
        number: 10,
        page: 1
      },
      noticeList: [],
      pageNumber: 1,
      paginationSize: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listNotice(this.requestData);
        if (data.returnCode === '01') {
          this.noticeList = data.noticeList;
          this.paginationSize = data.size;
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('获取采购公告列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 点击分页
    paginationData: function(data) {
      this.requestData.page = data;
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
#procurementNotice {
  width: 100%;
  .notice-title {
    font-family: 'Microsoft YaHei';
    padding: 25px 0;
    width: 1049px;
    margin: 0 auto;
    .notice-title-left {
      font-size: 24px;
      font-weight: 700;
      color: #707070;
      padding-bottom: 6px;
      border-bottom: 1px solid #2a85cb;
    }
    .notice-title-right {
      padding-top: 6px;
      font-family: 'Microsoft YaHei';
      font-size: 18px;
      font-weight: 700;
      color: #707070;
      padding-left: 50px;
    }
  }
  .notice-list-box {
    width: 1049px;
    margin: 0 auto;
    padding: 52px 42px 52px 0;
    display: flex;
  }
  .notice-list-box:hover {
    background-color: #fff;
    box-shadow: 2px 3px 3px #ccc;
  }
  .notice-list-box:hover .noticeList-redline {
    height: 100%;
  }
  .notice-list-box:hover .notice-list-title {
    background-color: #fff;
  }
  .noticeList-redline {
    height: 11px;
    width: 4px;
    background-color: #fb5b3b;
    margin: 0 auto;
    transition: height 0.5s;
  }
  .notice-list-title {
    color: #080808;
    font-size: 14px;
    font-family: 'Microsoft YaHei';
    font-weight: bold;
    max-width: 848px;
    float: left;
    background-color: #efefef;
    position: relative;
  }
  .notice-list-time {
    color: #fb5b3b;
    font-size: 14px;
    font-family: 'Microsoft YaHei';
    font-weight: bold;
    float: right;
  }
  .notice-list-content {
    color: #0b0b0b;
    font-family: 'SimSun';
    font-size: 14px;
    max-width: 940px;
  }
  .notice-title-box {
    width: 970px;
    height: 40px;
  }
  .eb-line {
    margin: 20px 0;
  }
}
</style>
